import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { updateUserRefSuccess, updateUserRefFailure } from "../../Action/dashboard/updateUserRefAction";
import { UPDATE_USER_REF } from "../../Action/actionTypes";

function* updateUserRefRequest(action) {
  try {
    const { _id, referralCode, userId } = action.payload;
    const { data } = yield notifyPromise(
      API.put(`/update-user-ref`, { _id, referralCode, userId }),
      "Assigning user under IB..."
    );

    if (data?.meta?.code === 200) {
      yield put(updateUserRefSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(updateUserRefFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(updateUserRefFailure());
  }
}

export function* watchUpdateUserRefAPI() {
  yield takeEvery(UPDATE_USER_REF, updateUserRefRequest);
}

export default function* rootSaga() {
  yield all([watchUpdateUserRefAPI()]);
}
